import api from '../../api/nodeBackApi';

export const sendMailUIDChange = async (uid, customerId, identifier) => {
  try {
    // Pasando los datos como query params, que es lo estándar para GET.
    const response = await api.get(`/api/make/newUIDNotification`, {
      params: {
        uid,
        identifier,
        customerId,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error sending UID change mail:', error);
    throw error;
  }
};

export const getCustomerCamarasByCustomerId = async (customerId) => {
  try {
    const response = await api.get(`/api/camara/getCustomerCamaras/${customerId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching customer camaras:', error);
    throw error;
  }
}

export const getCamaraById = async (id) => {
  try {
    const response = await api.get(`/api/camara/getCamaraByIdentifier/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching camara by identifier:', error);
    throw error;
  }
}

export const updateCamaraById = async (id, camaraData) => {
  try {
    const response = await api.put(`/api/camara/update/${id}`, camaraData);
    return response.data;
  } catch (error) {
    console.error('Error updating camara:', error);
    throw error;
  }
}

export const addDaysToCamaras = async (payload) => {
  try {
    const response = await api.post(`/api/camara/addDays`, payload);
    return response.data;
  } catch (error) {
    console.error('Error adding days to camaras:', error);
    throw error;
  }
};

export const checkReferralStatus = async (customerId) => {
  try {
    const response = await api.get(`/api/referral/customer/${customerId}`);
    return response.data;
  } catch (error) {
    console.error('Error checking referral status:', error);
    throw error;
  }
};
